export default "__VITE_ASSET__WbdWqSXd__"